import AUX from '../../../hoc/Aux_';
import EmployeeProjectsList from './EmployeeProjectsList';
import { useSelector } from 'react-redux';

const EmployeeProjectTab = () => {
  const projList = useSelector((state) => state?.Webtracker?.employeeProjects);

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="card-body">
                  <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-toggle="tab"
                        href="#home1"
                        role="tab"
                      >
                        <span className="d-none d-md-block">
                          Projects {projList?.count}
                        </span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-home-variant h5"></i>
                        </span>
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div className="tab-pane active" id="home1" role="tabpanel">
                      <EmployeeProjectsList data={projList?.rows} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default EmployeeProjectTab;
